const ReScheduleArrow = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.25 6.75H12.375C14.239 6.75 15.75 8.26104 15.75 10.125C15.75 11.989 14.239 13.5 12.375 13.5H9M2.25 6.75L5.25 3.75M2.25 6.75L5.25 9.75"
      stroke="#1369E9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ReScheduleArrow;
